/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Script from 'next/script';
import Style from './Boleto25Conteudos.css';
import CustomEmblaCarousel from '../CustomEmblaCarousel';
import Container from '@/components/atoms/Container';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function Boleto25Conteudos() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="boleto-conteudos">
        <ContainerHome24>
          <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2>
          <div className="is-mobi">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/como-identificar-fraudes-em-boletos.html"
                      target="_blank"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-36/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-36/capa.jpg" />
                        <img
                          src="static/amp/blog/post-36/capa.jpg"
                          alt="Mulher reconhecendo um golpe de boleto falso"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Fraudes em boletos: como identificar um boleto falso antes de pagar
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/o-que-saber-sobre-boleto-digital.html"
                      target="_blank"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-35/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-35/capa.jpg" />
                        <img
                          src="static/amp/blog/post-35/capa.jpg"
                          alt="casal realizando o pagamento do boleto de quitação"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Boleto digital: o que saber sobre essa forma de pagamento
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/como-gerar-um-boleto-bancario.html"
                      target="_blank"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-1/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-1/capa.jpg" />
                        <img
                          src="static/amp/blog/post-1/capa.jpg"
                          alt="Pagando boleto bancário pelo celular"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Como gerar um boleto bancário?
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <div className="cards-desk">
              <a
                href="blog/como-identificar-fraudes-em-boletos.html"
                target="_blank"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-36/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-36/capa.jpg" />
                  <img
                    src="static/amp/blog/post-36/capa.jpg"
                    alt="Mulher reconhecendo um golpe de boleto falso"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Fraudes em boletos: como identificar um boleto falso antes de pagar
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/o-que-saber-sobre-boleto-digital.html"
                target="_blank"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-35/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-35/capa.jpg" />
                  <img
                    src="static/amp/blog/post-35/capa.jpg"
                    alt="casal realizando o pagamento do boleto de quitação"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Boleto digital: o que saber sobre essa forma de pagamento
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/como-gerar-um-boleto-bancario.html"
                target="_blank"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-1/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-1/capa.jpg" />
                  <img
                    src="static/amp/blog/post-1/capa.jpg"
                    alt="Pagando boleto bancário pelo celular"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">Como gerar um boleto bancário?</h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Boleto25Conteudos;
